import { ALMHistoricalChartComponent } from './../common/alm-historical-chart.component';
import { SnapshotService } from './../../snapshot/snapshot.service';
import { AppConfig } from './../../app.config';
import { ALMLongTermBucketing } from './../../bucket/alm-long-term-bucketing';
import { ALMDashboardMetricData, walkAndBuildTreeNode, stampBreakDownDataWithTenorBuckets } from './../alm-dashboard';
import { DashboardMetricSet } from './../../dashboard/dashboard-metric';
import { AwsUtil } from '../../authentication/aws.service';
import { DashboardEventService } from '../../dashboard/dashboard-event.service';
import { Subscription } from 'rxjs';
import { Component, OnInit, ViewEncapsulation, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { SelectItem } from 'primeng/api';

import { convertFromCamelToHuman } from '@liquitics/transaction';
import {

    ALM_METRIC_CONFIGS,
    ALMMetricConfig,
    ALMBreakDownConfig,
    ALMBreakDownData,
} from '@liquitics/transaction';

import {

    GetALMBreakDownQueryDataResult,
    WebApiEndpoints,
    GetALMBreakDownQueryDataRequest,

} from '@liquitics/transaction';

import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import { createALMHistoricalData, ALMHistoricalData } from '../common/alm-historical-chart-generator';

@Component({
    selector: 'app-alm-manager',
    templateUrl: './alm-manager.component.html',
    styleUrls: ['./alm-manager.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ALMManagerComponent implements OnInit, OnDestroy, AfterViewInit {
    subscription: Subscription;
    viewMode = 'DASHBOARD';

    currentALMMetricDataResults: GetALMBreakDownQueryDataResult[];
    selectedMetricData: ALMDashboardMetricData;
    selectedMetricName: string;
    breakDownTreeNodes: TreeNode[];
    selectedBreakDownNode: TreeNode;
    selectedBreakDownPath: string;
    selectedBreakDownValues: string[];
    ladderTreeNodes: TreeNode[];
    historicalData: ALMHistoricalData[];

    breakDownConfigs: SelectItem[];
    selectedMetricConfig: ALMMetricConfig;
    selectedBreakDownConfig: ALMBreakDownConfig;
    ladderCharts: am4charts.Chart[];
    scenarioNames: string[];

    almBucketing: ALMLongTermBucketing;

    @ViewChild(ALMHistoricalChartComponent, { static: false }) historicalChartComponent: ALMHistoricalChartComponent;


    constructor(
        private dashboardEventService: DashboardEventService,
        private snapshotService: SnapshotService,
        private awsUtil: AwsUtil,
        private appConfig: AppConfig) {
        this.almBucketing = new ALMLongTermBucketing(this.appConfig.getTodayString());
    }

    ngOnInit() {
        this.subscription = this.dashboardEventService.dashboardMetricCategorySubject.subscribe({
            next: (metricSet: DashboardMetricSet) => {
                this.showMetricDetails(metricSet);
            }
        });
        this.scenarioNames = this.snapshotService.applicationConfiguration.scenarioNames;
        this.subscription.add(this.dashboardEventService.viewModeSelectionSubject.subscribe({
            next: (mode: string) => {
                this.viewMode = mode;
            }
        }));
    }

    ngAfterViewInit() {

    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    clearData() {
        this.breakDownTreeNodes = null;
        this.ladderTreeNodes = null;
        this.historicalData = null;
        this.selectedBreakDownPath = null;
        if (this.ladderCharts) {
            this.ladderCharts
                .forEach((ladderChart) => {
                    ladderChart.data = [];
                });
        }
        this.ladderCharts = [];
    }

    showMetricDetails(metricSet: DashboardMetricSet) {
        this.clearData();
        if (!metricSet) {
            this.selectedMetricData = null;
            return;
        }
        const metricData = metricSet.underlyingData as ALMDashboardMetricData;
        if (!metricData || !metricData.metricName) {
            this.selectedMetricData = null;
            return;
        }
        this.selectedMetricData = metricData;
        this.selectedMetricName = convertFromCamelToHuman(metricData.metricName);
        this.selectedMetricConfig = ALM_METRIC_CONFIGS
            .find((metricConfig: ALMMetricConfig) => {
                return metricConfig.name === metricData.metricName;
            });
        if (this.selectedMetricConfig.breakDownRollupType === 'NONE') {
            // This means that this metric config does not have any breakdowns
            this.selectedMetricData = null;
            return;
        }
        this.breakDownConfigs = this.selectedMetricConfig.breakDownConfigs
            .map((breakDownConfig: ALMBreakDownConfig) => {
                return { label: convertFromCamelToHuman(breakDownConfig.name), value: breakDownConfig } as SelectItem;
            });
        if (this.selectedMetricConfig) {
            this.selectedBreakDownConfig = this.selectedMetricConfig.breakDownConfigs[0];
        }
        this.showSelectedBreakDownConfig();
    }

    extractAmount(): number {
        return this.selectedMetricData.amount;
    }

    showSelectedScenario() {
        const breakDownData = this.currentALMMetricDataResults[0].breakDownData;
        const amount = this.extractAmount();
        const breakDownRootNode = {
            label: this.selectedMetricName,
            data: {
                index: 0,
                level: 0,
                breakDown: this.selectedMetricName,
                breakDownData: breakDownData,
                amounts: [amount],
            },
            amount: amount,
            amounts: [amount],
            expanded: true,
        } as TreeNode;
        walkAndBuildTreeNode(
            [this.selectedMetricConfig.breakDownRollupType],
            breakDownRootNode,
            breakDownData,
            ['bdn'],
            ['bdd'],
            ['bd1', 'bd2', 'bd3', 'bd4'],
            -1,
            this.selectedMetricData.currency,
            this.almBucketing);
        this.breakDownTreeNodes = [breakDownRootNode];
    }

    showSelectedBreakDownConfig() {
        this.clearData();
        this.awsUtil.webAPICall<GetALMBreakDownQueryDataResult>(WebApiEndpoints.QueryALMMetricData,
            {
                type: 'METRIC_LADDER',
                scenarioType: 'BASE',
                currency: this.selectedMetricData.currency,
                batchIdentifier: this.selectedMetricData.batchIdentifier,
                breakDownQueryConfigName: this.selectedMetricData.metricName,
                breakDown: this.selectedBreakDownConfig.name,
            } as GetALMBreakDownQueryDataRequest)
            .then((result: GetALMBreakDownQueryDataResult) => {
                this.currentALMMetricDataResults = [result];
                this.showSelectedScenario();
            });
    }

    showSelectedHistoricalBreakDownTrend() {
        this.historicalChartComponent.setToLoading();
        const request = {
            type: 'METRIC_TREND',
            scenarioType: 'BASE',
            currency: this.selectedMetricData.currency,
            batchIdentifier: this.selectedMetricData.batchIdentifier,
            breakDownQueryConfigName: this.selectedMetricData.metricName,
            breakDown: this.selectedBreakDownConfig.name,
            breakDownValues: this.selectedBreakDownValues,
        } as GetALMBreakDownQueryDataRequest;
        createALMHistoricalData(
            this.awsUtil,
            request,
            this.selectedMetricConfig.breakDownRollupType,
            this.selectedMetricData.currency,
            this.almBucketing
        )
            .then((historicalData: ALMHistoricalData[]) => {
                this.historicalData = historicalData;
            });
    }

    setSelectedScenario(scenario: string) {
        this.showSelectedScenario();
    }

    createLadderCharts() {
        if (!this.ladderCharts || this.ladderCharts.length === 0) {
            this.ladderCharts = [];
            for (let i = 0; i < this.selectedMetricConfig.ladderValueNames.length; i++) {
                const chart = am4core.create('ladderchartdiv' + i, am4charts.XYChart);
                chart.hiddenState.properties.opacity = 0; // this makes initial fade in effect
                chart.data = this.ladderTreeNodes;
                chart.logo.visible = false;

                const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
                categoryAxis.renderer.grid.template.location = 0;
                categoryAxis.dataFields.category = 'label';
                // categoryAxis.renderer.minGridDistance = 40;

                const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

                // let series = chart.series.push(new am4charts.CurvedColumnSeries());
                const series = chart.series.push(new am4charts.ColumnSeries());
                series.dataFields.categoryX = 'label';
                series.dataFields.valueY = 'amount' + i;
                series.tooltipText = '{valueY.value}';
                series.columns.template.strokeOpacity = 0;
                // series.columns.template.tension = 0.2;

                series.columns.template.fillOpacity = 0.75;
                // let hoverState = series.columns.template.states.create("hover");
                // hoverState.properties.fillOpacity = 1;
                // hoverState.properties.tension = 0.8;

                chart.cursor = new am4charts.XYCursor();

                // Add distinctive colors for each column using adapter
                series.columns.template.adapter.add('fill', (fill, target) => {
                    return chart.colors.getIndex(target.dataItem.index);
                });
                this.ladderCharts.push(chart);
            }
        } else {
            for (let i = 0; i < this.selectedMetricConfig.ladderValueNames.length; i++) {
                this.ladderCharts[i].data = this.ladderTreeNodes;
            }
        }
    }

    onDashboard() {
        this.dashboardEventService.dashboardMetricCategorySubject.next(null);
    }

    onBreakDownConfig() {
        this.showSelectedBreakDownConfig();
    }

    breakDownNodeSelected(event) {
        const ladderRootNode = {} as TreeNode;
        let breakDownData: ALMBreakDownData[] = event.node.data.breakDownData;
        // Add empty zero bucket points
        this.almBucketing.getAllBucketTenors()
            .forEach((bucketTenor: string) => {
                breakDownData.push(
                    {
                        almTenor: bucketTenor,
                        ln1: 0.0,
                        ld1: 1,
                        ln2: 0.0,
                        ld2: 1,
                        ln3: 0.0,
                        ld3: 1,
                        ln4: 0.0,
                        ld4: 1,
                    } as ALMBreakDownData
                )
            });
        breakDownData = stampBreakDownDataWithTenorBuckets(breakDownData, this.almBucketing);
        const numeratorFieldNames = this.selectedMetricConfig.ladderRollupTypes
            .map((type, i) => {
                return `ln${i + 1}`;
            });
        const denominatorFieldNames = this.selectedMetricConfig.ladderRollupTypes
            .map((type, i) => {
                return `ld${i + 1}`;
            });
        walkAndBuildTreeNode(
            this.selectedMetricConfig.ladderRollupTypes,
            ladderRootNode,
            breakDownData,
            numeratorFieldNames,
            denominatorFieldNames,
            ['almTenorBucket'],
            0,
            this.selectedMetricData.currency,
            this.almBucketing);
        this.ladderTreeNodes = ladderRootNode.children;
        const pathNames: string[] = [];
        let node = this.selectedBreakDownNode;
        while (node && node.data) {
            pathNames.unshift(convertFromCamelToHuman(node.data.breakDown));
            node = node.parent;
        }
        this.selectedBreakDownPath = pathNames.join(' > ');

        this.selectedBreakDownValues = [];
        let parentNode = event.node
        // We navigate the tree upwards getting the values to create the where conditions on the query
        // We check the parent's parent because we want to ignore the root node which is the metric total node, not a breakdown
        while (parentNode && parentNode.parent) {
            this.selectedBreakDownValues.unshift(parentNode.data.breakDown);
            parentNode = parentNode.parent;
        }

        this.showSelectedHistoricalBreakDownTrend();
        setTimeout(() => {
            this.createLadderCharts();
        }, 500);
    }
}
